"use client";
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { IUserData } from "@/types";
import React from "react";
interface Props {
    collaborativeAccounts: any[];
}
const numberofaccountstoshow = 3;
export default function Collaborative({ collaborativeAccounts }: Props) {
    const [accounts, setAccounts] = React.useState(new Map());
    React.useEffect(() => {
        const fetchUserData = async (userId: string) => {
            const userData = await fetch(
                `${process.env.NEXT_PUBLIC_API_SERVER_INTERNAL}/api/user/id/${userId}`
            )
                .then((res) => res.json())
                .catch(() => null);
            return userData;
        };
        const updateReplies = async () => {
            const userIdsToFetch = collaborativeAccounts
                .filter((account) => !accounts.get(account))
                .map((account) => account);
            const fetchedUsers = await Promise.all(
                userIdsToFetch.map((userId) => fetchUserData(userId))
            );
            const newUsers = new Map(accounts);
            collaborativeAccounts.forEach((userId, index) => {
                if (fetchedUsers[index]) {
                    newUsers.set(userId, fetchedUsers[index]);
                }
            });
            setAccounts(newUsers);
        };
        updateReplies();
        // Only run this effect when the ticket prop changes
    }, [collaborativeAccounts]);
    if (collaborativeAccounts.length <= numberofaccountstoshow) {
        return collaborativeAccounts.map((account, index) => {
            const info = accounts.get(account);
            if (!info) return;
            return (
                <TooltipProvider key={index}>
                    <Tooltip delayDuration={0}>
                        <TooltipTrigger>
                            <img
                                className="h-8 w-8 rounded-full border-2 border-success"
                                src={info.pic}
                                alt=""
                            />
                        </TooltipTrigger>
                        <TooltipContent>
                            <p>{info.username}</p>
                        </TooltipContent>
                    </Tooltip>
                </TooltipProvider>
            );
        });
    }
    return (
        <>
            {collaborativeAccounts
                .slice(0, numberofaccountstoshow)
                .map((account, index) => {
                    const info = accounts.get(account);
                    if (!info) return;
                    return (
                        <TooltipProvider key={index}>
                            <Tooltip delayDuration={0}>
                                <TooltipTrigger>
                                    <img
                                        className="h-8 w-8 rounded-full border-2 border-success"
                                        src={info.pic}
                                        alt=""
                                    />
                                </TooltipTrigger>
                                <TooltipContent>
                                    <p>{info.username}</p>
                                </TooltipContent>
                            </Tooltip>
                        </TooltipProvider>
                    );
                })}
            <TooltipProvider>
                <Tooltip delayDuration={0}>
                    <TooltipTrigger>
                        <div className="flex h-8 w-8 items-center justify-center rounded-full border-2 border-success bg-accent text-xs">
                            +
                            {
                                collaborativeAccounts.slice(
                                    numberofaccountstoshow
                                ).length
                            }
                        </div>
                    </TooltipTrigger>
                    <TooltipContent>
                        {collaborativeAccounts
                            .slice(numberofaccountstoshow)
                            .map((account, index) => {
                                const info = accounts.get(account);
                                if (!info) return;
                                return <p key={index}>{info.username}</p>;
                            })}
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </>
    );
}
